export default{tag:"w_Df",leading:"w_Dg",primary:"w_Dh",red:"w_Di",spark:"w_Dj",green:"w_Dk",blue:"w_Dl",purple:"w_Dm",gray:"w_Dn",secondary:"w_Do",tertiary:"w_Dp"};
